export const interestStatisticSelector = (state) => state.interest.statistic;
